import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getTableFilterConditions } from "../../../ducks/table/selectors";
import { useGeometrySelectionConditions } from "../../../hooks/geometrySelection/useGeometrySelectionConditions";
import { useTableActiveLayers } from "./useTableActiveLayers";

import { api } from "../../../evergis/api";
import { FilterConditionOperation } from "../../../components/LayerFilter/types";

export const useActiveLayersCounts = (): Record<string, number> => {
  const tableFilterConditions = useSelector(getTableFilterConditions);
  const geometrySelectionConditions = useGeometrySelectionConditions();
  const tableActiveLayers = useTableActiveLayers();
  const [result, setResult] = useState<Record<string, number>>({});

  useEffect(() => {
    if (tableFilterConditions === undefined && geometrySelectionConditions === undefined) {
      setResult({});

      return;
    }

    const promisesArray =
      tableActiveLayers?.map(layer => {
        return api.layers.getFilteredFeaturesCount({
          name: layer.name,
          condition: [tableFilterConditions?.[layer.name], geometrySelectionConditions?.[layer.name]]
            .filter(Boolean)
            .join(` ${FilterConditionOperation.AND} `),
        });
      }) ?? [];

    Promise.all(promisesArray).then(data => {
      setResult(
        tableActiveLayers?.reduce((acc: Record<string, number>, curr, index) => {
          return {
            ...acc,
            [curr.name]: data[index],
          };
        }, {}) ?? {},
      );
    });
  }, [
    tableFilterConditions,
    Array.isArray(tableActiveLayers) &&
      tableActiveLayers.length &&
      geometrySelectionConditions?.[tableActiveLayers[0].name],
  ]);

  return result;
};
